import pkgJSON from '../../package.json';
import {environment, isLocalhost } from "util/index";
import TimeService from "services/timeService";
import { createSlice } from "@reduxjs/toolkit";
import {ValidationResponse, ValidationResponseCheck } from '@npd-ng/adp-types';
import { IADPState, AppConfigExtended, Content, Views, ManifestProps, ServiceWorkerType, PreCacheVaidationStatus, NetworkConnectionState, NetworkConnectionStateObj, VerifySetUpCodeResponse, ValidationState, IValidationSummary, UpdateComponents, Battery, SessionDetails, IpcMessageType, DeviceVitalsInfo, checkStatus, CachedType, AppMode, FailureType } from 'Types/AppStateTypes';
import { DeviceMetricsService } from 'services/deviceMetricsService';
import { Manifest } from 'Types/ServiceTypes';
export const initialState: IADPState = {
    appState: {
        appLaunchId: undefined,
        appLaunchTime: new Date().toISOString(),
        appVersion: pkgJSON?.version,
        appCode: pkgJSON?.name,
        appBuildDate:undefined,
        releaseVersion: undefined,
        releaseBuildNumber: 0,
        releaseColors: [],
        releaseBorder: [],
        environment: undefined,
        configuration: undefined,
        currentView: "LoadingView",
        isPageReloaded: false,
        apiDomain: '',
        runtimePlatform: {
            platform: "Browser",
            version: "",
            userAgent: ""
        },
        selectedLanguage: TimeService.timeZone()=== "America/Puerto_Rico" ? "es" : "en",
        isCached: "Pending"
    },
    updateState: {
        isCheckForUpdateEnabled:true,
        appComponentVersions:[]
    },
    cacheValidation:{
        validationStatus: "NotStarted",
    },
    serviceWorkers:[],
    deviceState: {
        batteryState: {
            level: 100,
            charging: false
        },
        deviceId: undefined,
        deviceType: undefined,
        deviceModel: undefined,
        //@ts-ignore
        browserAgentData:{
            //@ts-ignore
            brands: navigator?.userAgentData?.brands,//@ts-ignore
            mobile:navigator?.userAgentData?.mobile,//@ts-ignore
            platform: navigator?.userAgentData?.platform //@ts-ignore
        }
    },
    sessionState: {
        selectedAssessmentMode: "online",
        appAccessedFor: "NotSelected",
        networkConnectionState: navigator?.onLine ? "Connected" : "N/A",
        networkChangeEvents:[],
        schoolDetails: undefined,
        lastKnownGoodState: "LoadingView",
        providedCode:undefined,
        selectedAssessmentLocation:undefined,
        locationError:false,
        homeButtonEnabled: false,
        exitButtonEnabled: true,
        confirmationModal: false,
    },
    deviceReadinessState: {
      validationState: undefined
    },
    deviceReadinessSummary:undefined,
    staticContent: undefined,
    currentLanguageContent: undefined
};
export const reducerSlice = createSlice({//TODO implement thunk for indexdb
    name:'rootState',
    initialState:initialState,
    reducers:{
        createSetConfigAction(state:IADPState,action:{type:string,payload:AppConfigExtended}){
            const payload = action.payload;
            state.appState.configuration = payload
        },
        createSetContentAction(state:IADPState,action:{type:string,payload:{en:Content,es:Content}}){
            const payload = action.payload;
            state.staticContent = payload
            state.currentLanguageContent = payload.en//TODO implement the langauge toggle
        },
        createSetInitialStateAction(state:IADPState,action:{type:string,payload:IADPState}){
            const payload = action.payload;
            state= payload
        },
        createSetViewAction(state:IADPState,action:{type:string,payload:Views}){
            if(!state.sessionState.failure){
                const payload = action.payload;
                const disabledScreens:Views[] = ["LoadingView", "FailureView" ,"RedirectionView" , "WaitView" , "UpdaterView", "DeviceValidationView", "ModeSelectionsView","WarningView"]
                const disabled= !disabledScreens.includes(payload)
                state.sessionState.exitButtonEnabled=disabled;
                state.sessionState.homeButtonEnabled=payload === "ModeSelectionsView" ? false : disabled;
                state.appState.currentView= payload
                const badViews:Views[] =["LoadingView", "FailureView" ,"RedirectionView" , "WaitView" , "UpdaterView","WarningView"]
                const goodView= !badViews.includes(payload)
                state.sessionState.lastKnownGoodState = goodView ? payload : state.sessionState.lastKnownGoodState
            }
        },
        createSetReleaseVersionAction(state:IADPState,action:{type:string,payload:Manifest}){
            const payload = action.payload;
            state.appState.releaseVersion= payload.manifest.product.version
        },
        createSetUpdateManfiestAction(state:IADPState,action:{type:string,payload:{manifest:ManifestProps}}){
            const payload = action.payload;
            state.appState.releaseVersion= payload.manifest.product.version
            state.appState.releaseBuildNumber = payload.manifest.product.buildNumber
            state.appState.releaseColors = payload.manifest.product.versionColors
            state.appState.releaseBorder = payload.manifest.product.versionBorderColors
        },
        createUpdateServiceWorkerDetailsAction(state:IADPState,action:{type:string,payload:ServiceWorkerType}){
            let serviceWorkers = [...state.serviceWorkers || []];
            const appComponentVersionArray = [...state.updateState.appComponentVersions];
            appComponentVersionArray.push({name:action.payload.appCode, version:action.payload.cachedVersion as string});
            if(state.serviceWorkers && state.serviceWorkers?.length > 0){
               const serviceWorker =  state.serviceWorkers.find((sw) => {
                return sw.appCode === action.payload.appCode 
            })
            const updatedSW = {...serviceWorker,...action.payload}
            serviceWorkers.push(updatedSW);
            }
            else {
                serviceWorkers.push(action.payload)
            }
            state.serviceWorkers= serviceWorkers,
            state.updateState.appComponentVersions= appComponentVersionArray
        },
        createUpdatePreChacheValidationStatusAction(state:IADPState,action:{type:string,payload:PreCacheVaidationStatus}){
            const payload = action.payload;
            let events = [...state.cacheValidation?.validationEvents|| []];
            events.push(payload)
            state.cacheValidation ={
                ...state.cacheValidation,
                validationStatus: action.payload.validationStatus,
                validationDetails: action.payload.validationDetails,
                validationEvents:events
            }   
            
        },
        createSetNetworkAction(state:IADPState,action:{type:string,payload:NetworkConnectionState}){
            const payload = action.payload;
            state.sessionState.networkConnectionState = payload;
            
        },
        createSetNetworkDetails(state:IADPState,action:{type:string,payload:NetworkConnectionStateObj}){
            const events = [...state.sessionState.networkChangeEvents];
            events.push(action.payload)
            state.sessionState=
                {
                    ...state.sessionState,
                    networkDetails: action.payload,
                    networkChangeEvents: events
                }
        },
        createUpdateProgressAction(state:IADPState,action:{type:string,payload:IpcMessageType}){
                state.updateState={
                    ...state.updateState,
                    updateEvents: action.payload
                }  
         },
        createUpdateSchoolAction(state:IADPState,action:{type:string,payload:VerifySetUpCodeResponse | undefined}){
            if(action.payload === undefined){
             state.sessionState={
                        ...state.sessionState,
                        providedCode:state.sessionState?.providedCode,
                        schoolDetails: action.payload
                       }
            }
            else{
            state.sessionState={
                    ...state.sessionState,
                    providedCode:action.payload?.setupCode ?? action.payload?.verificationCode,
                    schoolDetails: action.payload
                   }
            }
        },
        createSetAssessmentModeAction(state:IADPState,action:{type:string,payload:AppMode}){
            state.sessionState.appAccessedFor = action.payload
            state.sessionState.exitButtonEnabled=true;
            state.sessionState.homeButtonEnabled=true;
            state.appState.currentView = action.payload === "Assess" ? "AccessCodeValidationView" : "VerificationCodeValidationView"
            state.deviceReadinessState.deviceReadinessInfo ={
                deviceReadinessCheckPassed: false,
                state: 'ReadinessCheckInProgress',
                failureReason: [],
                readinessCheckStartedAt: new Date().toISOString(),
                readinessCheckCompletedAt: ""
            }
        },
        createValidationAction(state:IADPState,action:{type:string,payload:ValidationState}){
            if(action.payload){
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=false;
            }
            else{
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=true;
            }
            state.deviceReadinessState.validationState= action.payload
        },
        createSetDeviceReadinessSummary(state:IADPState,action:{type:string,payload:(ValidationResponse & checkStatus)[]}){
            const results = action.payload;
            const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
            state.deviceReadinessState.deviceReadinessInfo= {
                readinessCheckStartedAt : state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt || new Date().toISOString(),
                failureReason:failedChecks,
                deviceReadinessCheckPassed:failedChecks.length> 0 ? false: true,
                readinessCheckCompletedAt: new Date().toLocaleDateString(),
                state:"ReadinessCheckCompleted"

            }
            state.deviceReadinessSummary= state?.deviceReadinessSummary ? ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: failedChecks?.length > 0 ? "Failure" : "Success",
                    responses:[...action.payload,...state.deviceReadinessSummary.responses] 
                } as IValidationSummary) : ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: failedChecks?.length > 0 ? "Failure" : "Success",
                    responses: [...action.payload]
                } as IValidationSummary)
            
        },
        createSetCached(state:IADPState,action:{type:string,payload:CachedType}){
            state.appState.isCached= action.payload
        },
        createSetSessionDetailsAction(state:IADPState,action:{type:string,payload:Record<string, unknown>}){
            const sessionDetails= action.payload as SessionDetails
            const getView =(): Views=>{
                if(state.sessionState.failure ){
                    return state.appState.currentView
                }
                else if(sessionDetails.networkConnectionState !== "Connected"){
                    state.sessionState.failure = "NoInternetConnectionDetected"
                    return "FailureView"
                }
                else {
                    state.sessionState.homeButtonEnabled= true;
                    return isLocalhost() ? "ModeSelectionsView" : "UpdaterView"
                }
            }
            const lastKnownGoodState = state.appState.currentView;
           state.cacheValidation={
                    ...state.cacheValidation,
                    validationStatus:!isLocalhost() && sessionDetails.networkConnectionState === "Connected" ? "InProgress" :  "Complete",
                    validationDetails:!isLocalhost() && sessionDetails.networkConnectionState === "Connected" ? 
                    "Initiating service worker validation": "Skip service worker validation",
                },
                state.appState={
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                environment: sessionDetails.environment,
                runtimePlatform: sessionDetails.runtimePlatform,
                currentView: getView(),
                isPageReloaded: sessionDetails.isPageReloaded
               }, 
               state.sessionState={
                ...state.sessionState,
                lastKnownGoodState:lastKnownGoodState,
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               },
                state.deviceState={
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType,
                    systemInfo: sessionDetails.systemInfo
                },
                state.updateState.isCheckForUpdateEnabled= sessionDetails?.isCheckForUpdateEnabled !== undefined ? sessionDetails.isCheckForUpdateEnabled : false
        },
        createSetUpdateComponentVersionsAction(state:IADPState,action:{type:string,payload:UpdateComponents}){
            const appComponentVersionArray = [...state.updateState.appComponentVersions];
            appComponentVersionArray.push(action.payload);
            state.updateState.appComponentVersions= appComponentVersionArray
        }, 
        createSetBatteryAction(state:IADPState,action:{type:string,payload:Battery}){
            const batteryPayload = action.payload;
            state.deviceState.batteryState=batteryPayload
            DeviceMetricsService().patchDeviceMetrics(state)  
        },
        createSetExitAction(state:IADPState){
            window.close()//TODO see if we need to capture anything else befoer we close the app Also moving forward use this action instead of window.close so we can control the behavior
        }, 
        createSetHomeAction(state:IADPState){
            state.sessionState.schoolDetails = undefined;
            state.sessionState.appAccessedFor = "NotSelected"
            state.sessionState.selectedAssessmentLocation = undefined;
            state.sessionState.lastKnownGoodState = "ModeSelectionsView"
            state.deviceReadinessSummary = undefined;
            state.sessionState.providedCode = undefined;
            state.sessionState.locationError = false;
            state.deviceReadinessState.validationState=undefined;
            state.sessionState.exitButtonEnabled=true;
            state.sessionState.homeButtonEnabled=false;
            state.appState.currentView = "ModeSelectionsView";
            state.sessionState.failure = undefined
            state.sessionState.confirmationModal = false;

        }, 
        createTryAgainAction(state:IADPState){
            state.deviceReadinessState.validationState=undefined;
            state.appState.currentView = state.sessionState.lastKnownGoodState;
            state.sessionState.failure = undefined
            state.sessionState.confirmationModal = false;

        }, 
        createSetSwitchLanguage(state:IADPState,action:{type:string,payload:'en' | 'es'}){
            if(state.staticContent)state.currentLanguageContent = state.staticContent[action.payload];
        }, 
        createSetDeviceVitalsInfo(state:IADPState,action:{type:string,payload:DeviceVitalsInfo[]}){
            const results = action.payload;
            state.deviceReadinessState.deviceVitalsInfo= results
        },
        createFailureAction(state:IADPState,action:{type:string,payload:FailureType}){
            if(!state.sessionState.failure){
                const results = action.payload;
                state.sessionState.failure= results;
                state.sessionState.exitButtonEnabled=true;
                state.sessionState.homeButtonEnabled=true;
                state.sessionState.lastKnownGoodState = state.appState.currentView;
                state.appState.currentView = "FailureView"
            }
        },
        createSetConfirmationModalAction(state:IADPState,action:{type:string,payload:boolean}){
            const results = action.payload;
            state.sessionState.confirmationModal = results;
        }
             
            
    }
})
export const { createSetConfigAction,createSetContentAction,createSetInitialStateAction,createSetViewAction,createSetReleaseVersionAction,createUpdateServiceWorkerDetailsAction,createUpdatePreChacheValidationStatusAction,createSetNetworkAction,createSetNetworkDetails,createUpdateProgressAction,createUpdateSchoolAction,createSetAssessmentModeAction, createValidationAction,createSetDeviceReadinessSummary,createSetSessionDetailsAction,createSetUpdateComponentVersionsAction,createSetBatteryAction,createSetExitAction,createSetHomeAction,createTryAgainAction,createSetSwitchLanguage,createSetDeviceVitalsInfo, createSetUpdateManfiestAction, createSetCached, createSetConfirmationModalAction, createFailureAction } = reducerSlice.actions
export default reducerSlice.reducer
